module.exports = __webpack_public_path__ + "img/wp-existing-habit-card7.afd19c86.jpg";